import {z} from 'zod';
import {MediaItemSchema} from "../../api/media-item-schema";
import {ApiResponseSchema} from "../../api/api-response-schema";
import {TechnologySchema} from "../technologies/technologies.schema";

export const WorkSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  title: z.string(),
  description: z.string(),
  technologies: z.array(TechnologySchema),
  cover_foto: MediaItemSchema.nullable().optional(),
  images: z.array(MediaItemSchema).nullable().optional(),
});

export type Work = z.infer<typeof WorkSchema>;
const WorkPreviewArraySchema = z.array(WorkSchema);

export type WorkResponse = z.infer<typeof WorkResponseSchema>;


export const WorkResponseSchema = ApiResponseSchema(
  z.array(WorkSchema),
);
export const WorkDetailsApiResponseSchema = ApiResponseSchema(WorkSchema);

export type WorkSchemaKey = keyof typeof WorkSchema.shape;

export const WorkParams = <const>{
  populate: <WorkSchemaKey[]>['cover_foto', 'images', 'technologies'],
  fields: <WorkSchemaKey[]>[
    'id',
    'documentId',
    'title',
    'description',
  ],
};
